import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Section } from '@models/condition.models';
import {
  CardComponent,
  DifferentialCardComponent,
  SequelaeCardComponent,
  InvolvementCardComponent,
} from '@ui/pages/conditions-page/condition-sheet/sections/cards';
import { MarginPanelComponent } from '@ui/pages/conditions-page/condition-sheet/sections/margin-panel/margin-panel.component';

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CardComponent,
    MarginPanelComponent,
    DifferentialCardComponent,
    SequelaeCardComponent,
    InvolvementCardComponent,
  ],
})
export class SectionComponent {
  @Input() section!: Section;
  @Input() headingLevel: number = 3;
}
